import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Switch } from "@/components/ui/switch";

const Label = ({ children }) => <p className="mb-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-slate-400">{children}</p>;
const field = "h-10 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm text-slate-900 outline-none focus:border-[#0066FF] focus:bg-white";

export const CatalogFilters = ({ sp, update, cats, slug, sorts, onPick }) => {
  const [q, setQ] = useState(sp.get("q") || "");
  const [min, setMin] = useState(sp.get("min") || "");
  const [max, setMax] = useState(sp.get("max") || "");
  useEffect(() => {
    setQ(sp.get("q") || "");
  }, [sp]);
  const qs = sp.toString() ? `?${sp.toString()}` : "";
  const catLink = (s) => `${s ? `/categoria/${s}` : "/catalogo"}${qs.replace(/([?&])page=\d+&?/, "$1")}`;

  return (
    <div className="space-y-8" data-testid="catalog-filters">
      <form onSubmit={(e) => { e.preventDefault(); update({ q: q.trim() }); onPick?.(); }}>
        <Label>Cerca</Label>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome, modello, codice…" data-testid="filter-search-input" className={field} />
      </form>
      <div>
        <Label>Categorie</Label>
        <div className="flex flex-col gap-0.5 text-sm">
          <Link to={catLink(null)} onClick={onPick} data-testid="filter-category-all" className={`rounded-lg px-2 py-1.5 ${!slug ? "bg-[#0066FF]/10 font-semibold text-[#0066FF]" : "text-slate-600 hover:text-slate-900"}`}>Tutte</Link>
          {cats.filter((c) => c.count > 0).map((c) => (
            <Link key={c.slug} to={catLink(c.slug)} onClick={onPick} data-testid={`filter-category-${c.slug}`}
              className={`flex justify-between rounded-md px-2 py-1.5 ${c.parent_path ? "pl-5 text-[13px]" : ""} ${slug === c.slug ? "bg-[#0066FF]/10 font-semibold text-[#0066FF]" : "text-slate-600 hover:text-slate-900"}`}>
              <span>{c.name}</span><span className="font-mono text-xs text-slate-400">{c.count}</span>
            </Link>
          ))}
        </div>
      </div>
      <div>
        <Label>Prezzo (€)</Label>
        <div className="flex gap-2">
          <input type="number" min="0" value={min} onChange={(e) => setMin(e.target.value)} placeholder="Min" data-testid="filter-price-min" className={field} />
          <input type="number" min="0" value={max} onChange={(e) => setMax(e.target.value)} placeholder="Max" data-testid="filter-price-max" className={field} />
        </div>
        <button onClick={() => { update({ min, max }); onPick?.(); }} data-testid="filter-price-apply" className="mt-2 h-9 w-full rounded-xl bg-[#0A0B0E] text-sm font-medium text-white transition-colors hover:bg-[#0066FF]">Applica</button>
      </div>
      <label className="flex items-center justify-between text-sm text-slate-900">
        <span>Solo offerte</span>
        <Switch checked={sp.get("offerte") === "1"} onCheckedChange={(v) => update({ offerte: v ? "1" : "" })} data-testid="filter-offers-switch" />
      </label>
      <div>
        <Label>Ordina per</Label>
        <select value={sp.get("sort") || "featured"} onChange={(e) => update({ sort: e.target.value })} data-testid="filter-sort-select"
          className={field}>
          {sorts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
    </div>
  );
};
